import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';            
import { CustomResponse } from '@ascschool/model/custom-response.model';
import { PolicyOfStudent } from '@ascschool/model/school/policy-of-student.model';
import { PolicyOfStudentService } from '@ascschool/services/school/policy-of-student.service';

@Component({
  selector: 'app-policy-of-student-popup',
  templateUrl: './policy-of-student-popup.component.html',
  styleUrls: ['./policy-of-student-popup.component.scss']
})
export class PolicyOfStudentPopupComponent implements OnInit {
  @Input() type: any;
  @Input() studentId: number;
  @Input() dataTransmission: any;
  itemPolicy: PolicyOfStudent = new PolicyOfStudent();
  response: CustomResponse = new CustomResponse(); 
  isEditMode = false; 
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private policyOfStudentService: PolicyOfStudentService,
    private msg: NzMessageService, 
    public utilsService: UtilsService, 
  ) {
  }

  ngOnInit() {
    this.itemPolicy.studentId = this.studentId;
    if (this.dataTransmission && this.dataTransmission.id > 0) {
      this.isEditMode = true;
      this.policyOfStudentService.getById(this.dataTransmission.id).subscribe((res: PolicyOfStudent) => {
        this.itemPolicy = res;
      });
    } else {
      this.isEditMode = false;
    } 
  }
  UpdateClose() {
    if (this.itemPolicy.policyName && this.itemPolicy.policyName != '') {
      this.policyOfStudentService.addOrUpdate(this.itemPolicy).subscribe(res => {
        if (res.statusCode == 0) {
          this.utilsService.notifyResponse(res);
          this.close();
        } else {
          this.utilsService.notifyResponse(res);
        }
      });
    } else {
      this.msg.warning('Vui lòng nhập trường bắt buộc');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(this.response);
  }
  
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
}
